<template>
  <router-link :to="(path || '/detail') + '/?prevPage=' + prevPage + '&id=' + course.id" class="course-item-wrapper">
    <i class="cover" :style="{ backgroundImage: 'url(' + course.playImage + ')' }"></i>
    <div class="content">
      <label class="title">
        <span class="tag">{{course.chapterCount}}集</span>
        <span class="name">
          <span>{{course.name}}</span>
          <span class="free" v-if="isFree">会员免费</span>
        </span>
      </label>
      <p class="intro">{{course.shortIntro}}</p>
      <div class="user-count">{{course.readCount}}人正在学习</div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'CourseItem',
  props: {
    course: {
      type: Object,
      default: () => {
        return {}
      },
    },
    isFree: {
      type: Boolean,
      default: false,
    },
    prevPage: String,
    path: String,
  },
};
</script>

<style scoped lang="scss">
.course-item-wrapper {
  display: flex;
  align-items: flex-start;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
  text-decoration: none;

  .cover {
    flex-grow: 0;
    flex-shrink: 0;
    width: 18.75vw;
    height: 15vw;
    background-size: cover;
    background-position: center;
  }

  .content {
    width: 0;
    flex-grow: 1;
    flex-shrink: 1;
    margin-left: 10px;
  }

  .title {
    display: flex;
    font-size: 14px;
    line-height: 18px;
    color: #101010;
    margin-bottom: 3px;
  }

  .tag {
    display: inline-block;
    min-width: 30px;
    text-align: center;
    height: 18px;
    line-height: 18px;
    box-sizing: border-box;
    font-size: 10px;
    color: #de0008;
    border: 1px solid #de0008;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    margin-right: 5px;
  }

  .name {
    flex-grow: 1;
    flex-shrink: 1;
    width: 0;
    display: flex;
    justify-content: space-between;
  }

  .free {
    flex-grow: 0;
    flex-shrink: 0;
    color: #e51c23;
    margin-left: 5px;
  }

  .intro {
    font-size: 10px;
    color: rgba(0, 0, 0, .6);
    margin: 0 0 3px;
  }

  .user-count {
    font-size: 10px;
    color: #101010;
    line-height: 16px;
    background-image: url('../../assets/avatar.png');
    background-repeat: no-repeat;
    background-size: contain;
    padding-left: 20px;
  }
}
</style>
